import React, { FC, memo } from 'react'
import { Item, Separator, StyledStatsBar } from './stats-styles'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import { FormattedStats } from '../../../../../models/property-details-page/stats-model'
import { theme, Typography } from 'react-components'

type StatsBarProps = {
    stats: FormattedStats | null
    shouldDisplayAll?: boolean
}

const statsConfig = [
    { key: 'stats.bedrooms' },
    { key: 'stats.bathrooms' },
    { key: 'stats.personCount' },
    { key: 'stats.qmSize' },
]

const Statsbar: FC<StatsBarProps> = ({ stats, shouldDisplayAll = false }) => {
    if (!stats || isEmpty(get(stats, 'stats'))) {
        return null
    }

    let firstStat = true
    if (shouldDisplayAll) {
        return (
            <StyledStatsBar>
                {statsConfig.map(({ key }) => {
                    const value = get(stats, key)
                    if (!value) {
                        return null
                    }

                    const showSeparator = !firstStat
                    firstStat = false
                    return (
                        <Item key={key}>
                            <Typography variant="button" fontWeight={400} lineHeight={1.375}>
                                {showSeparator && <Separator>·</Separator>}
                                {value}
                            </Typography>
                        </Item>
                    )
                })}
            </StyledStatsBar>
        )
    }

    return (
        <StyledStatsBar>
            {get(stats, 'stats.qmSize') && (
                <Item>
                    <Typography variant="button" fontWeight={400} lineHeight={1} color="tfwBlack40">
                        {get(stats, 'stats.qmSize')}
                    </Typography>
                </Item>
            )}
            {get(stats, 'stats.personCount') && (
                <Item>
                    <Typography variant="button" fontWeight={400} lineHeight={1} color="tfwBlack40">
                        <Separator>·</Separator>
                        {get(stats, 'stats.personCount')}
                    </Typography>
                </Item>
            )}
        </StyledStatsBar>
    )
}

export default memo(Statsbar)
